import { FC, useContext, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useAdminClaimsApi } from "../../http/claims/api";
import { UpsertClaim } from "../../http/claims/types";
import Header from "../ui/Header";
import Panel from "../ui/Panel";
import ClaimForm, { ClaimFormBody } from "./ClaimForm";

const NewClaim: FC = () => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const claimsApi = useAdminClaimsApi();
  const navigate = useNavigate();

  const [params] = useSearchParams();
  const carId = params.get("car_id");

  const onSubmit = async (formData: ClaimFormBody) => {
    const body: UpsertClaim = {
      carId: carId || formData.car?.id || "",
      driverId: formData.driver?.id ?? "",
      subsidiaryId: formData.subsidiary?.id ?? "",
      number: formData.number || null,
      status: formData.status.value,
      openingDate: formData.openingDate,
      closingDate: formData.closingDate,
      incidentDate: formData.incidentDate,
      typeId: formData.type?.id ?? "",
      description: formData.description,
      damageValueGross: formData.damageValueGross ?? undefined,
      damageValueNet: formData.damageValueNet ?? undefined,
      damageValueCurrency: formData.damageValueCurrency?.value,
      settledAmountGross: formData.settledAmountGross ?? undefined,
      settledAmountNet: formData.settledAmountNet ?? undefined,
      settledAmountCurrency: formData.settledAmountCurrency?.value,
      currentVersionNumber: 1,
    };

    setIsSubmitting(true);
    try {
      const response = await claimsApi.insertAdminClaim(body);
      dispatch(showSuccessNotification(i18n.t));

      const redirectUrl = params.get("redirect_uri");
      navigate(redirectUrl || `/admin/claims/${response.id}`);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header title={i18n.t.claims.new} />
      <Panel>
        <ClaimForm isDisabled={isSubmitting} onSubmit={onSubmit} carId={carId} />
      </Panel>
    </>
  );
};

export default NewClaim;
